export default "__VITE_ASSET__BLv3F9z2__"